import { ContentCompetency } from '@backrs_ui/common-ui/src/models/nugget';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';
import { selectIsSharedSessionActive } from '../sharedSession/sharedSession';
import type { RootState } from '../store';

export const contentCompetencyApi = createApi({
  reducerPath: 'contentCompetencyApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getCompetencyBySlug: build.query<ContentCompetency, string>({
      queryFn: async (
        slug,
        queryApi,
        _extraOptions,
        baseQuery,
      ): Promise<{ data: ContentCompetency }> => {
        const state = queryApi.getState() as RootState;
        const isSharedSession: boolean = selectIsSharedSessionActive(state);

        const url: string = isSharedSession
          ? `shared/solution-session/competency/${slug}`
          : `content-competency/slug/${slug}`;

        return baseQuery({ url }) as Promise<{ data: ContentCompetency }>;
      },
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const {
  useGetCompetencyBySlugQuery,
  usePrefetch: usePrefetchContentCompetency,
  util: { resetApiState },
} = contentCompetencyApi;
